// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--W28kr","icon":"_02712f2b3b--icon--M5luq","label":"_02712f2b3b--label--LF0xM"};